import { useState, useCallback } from "react";
import useAction from "./useAction";
import { SwitchParams } from "../OverviewPopper/type";
import Cookies from "js-cookie";
import useSubAccountListen from "./useSubAccountListen";

const useSwitchAccount = (base?: string) => {
  const { getToken } = useAction(base);

  const [isFatching, setIsFatching] = useState(false);

  const { triggerSubAccountChange } = useSubAccountListen();

  const switchTo = useCallback(
    async (params: SwitchParams) => {
      try {
        if (isFatching) return;
        setIsFatching(true);
        Cookies.set("isSwitching", "1", { expires: 365 });
        const res = await getToken(params);
        const response = res as unknown as { code: number; data: { token: string }; msg: string };
        if (response.code === 200 && response.data.token) {
          Cookies.set("token", response.data.token, { expires: 365 });
          if (params.type === "MAIN_TO_SUB" || params.type === "SUB_TO_SUB") {
            Cookies.set("Global-AccountType", "NORMAL_SUB_ACCOUNT", { expires: 365 });
          }
          if (params.type === "SUB_TO_MAIN") {
            Cookies.set("Global-AccountType", "MAIN", { expires: 365 });
          }
          triggerSubAccountChange(params);
          // eslint-disable-next-line @typescript-eslint/no-unused-expressions
          window && window.location.reload();
        } else {
          setIsFatching(false);
          Cookies.remove("isSwitching");
          console.error("switchTo error", response.msg);
        }
      } catch (error) {
        setIsFatching(false);
        console.error(error);
      }
    },
    [triggerSubAccountChange, getToken, isFatching]
  );

  return {
    switchTo
  };
};

export default useSwitchAccount;
